export default {
    // Navbar
    nav: {
      home: 'Inicio',
      about: 'Sobre Mí',
      strategies: 'Estrategias',
      performance: 'Rendimiento',
      portfolioBuilder: 'Constructor de Portfolio',
      insights: 'Análisis',
      reports: 'Reportes Semanales',
      terminal: 'Quant Lab',
      contact: 'Contacto',
      institutional: 'Inversores Institucionales',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: 'Quantitative Trading · Estrategias Sistemáticas',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: 'Quantitative Analyst desarrollando estrategias algorítmicas con retornos anualizados superiores al',
        cagr: '40% CAGR',
        and: 'y',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: 'Con',
        drawdowns: 'drawdowns',
        additionalMiddle: 'menores a',
        drawdownValue: '15%',
        additionalAnd: 'e históricos de más de',
        years: '20 años',
        ctaPrimary: 'Explorar Estrategias',
        ctaSecondary: 'Sobre Mí',
      },
      featured: {
        label: 'Estrategia Destacada',
        cta: 'Explorar ARES →',
        subtitle: 'Excelencia en Market Timing',
        description: 'Sistema cuantitativo desarrollado con rigor académico. Validado en casi 20 años de datos históricos, incluyendo crisis de 2008, COVID-19 y ciclos de tipos 2022-2024.',
      },
      tech: {
        label: 'Infraestructura Cuantitativa',
        title: 'HERRAMIENTAS MATEMÁTICAS Y ',
        titleAccent: 'COMPUTACIONALES',
        footer: 'Estrategias sistemáticas validadas con backtesting riguroso en datos de grado institucional',
      },
      timeline: {
        label: 'Trayectoria Profesional',
        title: 'HITOS ',
        titleAccent: 'PROFESIONALES',
        milestones: [
          {
            title: 'Grado en Física',
            description: 'Finalización del grado universitario con especialización en física teórica y matemática aplicada.',
          },
          {
            title: 'Master en Finanzas Cuantitativas',
            description: 'Formación especializada en modelización matemática, análisis cuantitativo y desarrollo de estrategias algorítmicas.',
          },
          {
            title: 'Hedge Fund + Estrategia Algorítmica',
            description: 'Inicio en hedge fund español. Desarrollo e implementación de estrategia algorítmica basada en dividendos.',
          },
          {
            title: 'IG Group (FTSE 100)',
            description: 'Incorporación al broker IG Group, componente del índice FTSE 100, trabajando en desarrollo cuantitativo.',
          },
          {
            title: 'Estrategias en Producción',
            description: 'Puesta en producción de múltiples estrategias algorítmicas con capital real. Portfolio systematic trading operativo.',
          },
        ],
      },
      features: {
        title: '¿Por qué invertir con estrategias cuantitativas?',
        subtitle: 'Sistemas algorítmicos basados en datos, backtesting riguroso y gestión de riesgo institucional',
        items: [
          {
            title: 'Momentum & Timing',
            description: '+40% CAGR en estrategias de momentum y timing de mercado validadas en 15 años de datos históricos'
          },
          {
            title: 'Modelos Bayesianos',
            description: 'Hidden Markov Models para detección de régimen de mercado y adaptación dinámica'
          },
          {
            title: 'Market Neutral',
            description: 'Estrategias long-short con análisis Beta/R² correlacional para reducir exposición direccional'
          },
          {
            title: 'Sistemas Automatizados',
            description: 'Trading intraday totalmente automatizable en prop firms y brokers institucionales'
          },
          {
            title: 'Multi-Asset',
            description: 'US equities, índices, cripto, volatilidad (VIX) - diversificación real'
          },
          {
            title: 'Track Record Institucional',
            description: 'Experiencia gestionando carteras de hasta $200M en hedge funds y brokers FTSE 100'
          }
        ]
      },
      cta: {
        title: '¿Listo para empezar?',
        subtitle: 'Descubre mis estrategias en Darwinex, eToro y Wikifolio, o lee mi análisis cuantitativo en Substack',
        ctaPrimary: 'Dónde Invertir',
        ctaSecondary: 'Contactar'
      }
    },

    // About Me Page
    about: {
      title: 'Analista Cuantitativo',
      intro1: 'Quantitative Analyst con formación en',
      physics: 'Física (BSc)',
      and: 'y',
      intro2b: 'Actualmente candidato a CFA (Chartered Financial Analyst) — la certificación más prestigiosa y reconocida globalmente en la industria de inversión.',

      finance: 'finanzas cuantitativas (MSc)',
      intro2: '. Actualmente trabaja en un broker de Londres (FTSE 100), donde desarrolla modelos estadísticos y estrategias de trading sistemático.',
      intro3: 'Con experiencia previa gestionando carteras de hasta',
      trackRecordTitle2: 'Construyendo estrategias cuantitativas que generan retornos consistentes ajustados por riesgo en cualquier régimen de mercado.',
      trackRecordParagraph1: 'La experiencia profesional incluye optimización de estrategias sistemáticas, mejorando retornos ajustados por riesgo del 12% al 23% anualizado, y contribuyendo a gestión de portafolios e investigación que cubre activos bajo gestión superiores a €200M.',
      trackRecordParagraph2: 'Ha diseñado y testeado más de 40 modelos cuantitativos en acciones, derivados y renta fija. Cada estrategia ha sido testeada en décadas de datos históricos, así como validada mediante paper trading en vivo y condiciones de mercado reales.',
      trackRecordParagraph3: 'Individualmente, cada estrategia apunta a riesgo controlado dentro de su clase de activo. Combinadas en un portafolio diversificado, alcanzan ratios de Sharpe superiores a 1.5 y drawdowns máximos por debajo del -15%, con correlación casi nula a benchmarks tradicionales.',
      trackRecordDisclaimer: 'Resultados basados en backtesting y paper trading en vivo. Rendimientos pasados no garantizan retornos futuros. Todos los retornos son hipotéticos salvo que se especifique explícitamente como live.',
      trackRecordParagraph4: 'Desde portafolios de acciones basados en momentum hasta arbitraje estadístico market-neutral, desde captura de volatilidad hasta macro cuantitativo, ya seas un inversor retail buscando exposición sistemática o una institución buscando fuentes de retorno descorrelacionadas, construimos estrategias ajustadas a tu perfil de riesgo y objetivos.',

      amount: '$200M en un hedge fund español',
      intro4: ', y en pricing y gestión de riesgo de derivados energéticos en un fondo de commodities, combina rigor matemático, machine learning y conocimiento profundo de mercados para construir algoritmos robustos y reproducibles.',
      trackRecordTitle: 'Historial',
      trackRecordDescription: 'Construyendo estrategias cuantitativas que generan retornos ajustados al riesgo consistentes en cualquier régimen de mercado. Nuestro track record habla a través de los números: doce estrategias independientes diseñadas para minimizar drawdowns mientras maximizan alpha, cada una testeada contra décadas de datos históricos y validada en paper trading en vivo. Individualmente, cada estrategia busca un riesgo controlado dentro de su clase de activo. Combinadas en un portfolio diversificado, alcanzan ratios de Sharpe por encima de 1.5 y drawdowns máximos contenidos por debajo del -15%, con correlación cercana a cero respecto a benchmarks tradicionales. Desde portfolios de momentum en renta variable hasta arbitraje estadístico market-neutral, desde captura de volatilidad hasta macro cuantitativo, ya seas un inversor particular buscando exposición sistemática o una institución buscando fuentes de retorno descorrelacionadas, construimos estrategias que se adaptan a tu perfil de riesgo y objetivos.',
      expertiseTitle: 'Especialización',
      expertise: [
        '+40% CAGR en estrategias de momentum y timing',
        'Modelos bayesianos con Hidden Markov Models para detección de régimen',
        'Estrategias market neutral con análisis Beta/R² correlacional',
        'Sistemas intraday totalmente automatizables en prop firms',
        'Multi-asset: US equities, índices, cripto, volatilidad (VIX)',
        'Track record institucional: gestión de carteras de hasta $200M',
      ],
      toolsTitle: 'Herramientas Matemáticas y Computacionales',
      toolsSubtitle: 'Tecnologías y frameworks que utilizo para investigación cuantitativa y trading sistemático',
      clickToFlip: 'Pulsa para ver más',
      clickToFlipBack: 'Pulsa para volver',
      clickForDetails: 'Click para más detalles →',
      clickToClose: 'Click para cerrar ←',
      tools: {
        python: {
          name: 'Python',
          description: 'Lenguaje principal para backtesting, análisis estadístico y desarrollo de estrategias'
        },
        numpy: {
          name: 'NumPy',
          description: 'Paquete fundamental para computación numérica y operaciones con arrays'
        },
        pandas: {
          name: 'Pandas',
          description: 'Manipulación y análisis de datos de alto rendimiento para series temporales'
        },
        scikit: {
          name: 'Scikit-learn',
          description: 'Modelos de machine learning para reconocimiento de patrones y análisis predictivo'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: 'Framework de deep learning para modelado de comportamientos complejos del mercado'
        },
        pytorch: {
          name: 'PyTorch',
          description: 'Redes neuronales dinámicas para investigación avanzada en deep learning'
        },
        git: {
          name: 'Git',
          description: 'Control de versiones para gestión de código y desarrollo colaborativo'
        },
        vscode: {
          name: 'VS Code',
          description: 'IDE profesional para desarrollo eficiente de código y debugging'
        },
        jupyter: {
          name: 'Jupyter',
          description: 'Notebooks interactivos para investigación, visualización y prototipado de estrategias'
        },
        quantlib: {
          name: 'QuantLib',
          description: 'Librería de finanzas cuantitativas para pricing de derivados y gestión de riesgo'
        },
        backtrader: {
          name: 'Backtrader',
          description: 'Framework Python para backtesting y trading en vivo de estrategias'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: 'Base de datos relacional robusta para almacenamiento de datos financieros estructurados'
        },
        mongodb: {
          name: 'MongoDB',
          description: 'Base de datos NoSQL para almacenamiento flexible de datos de mercado no estructurados'
        },
        docker: {
          name: 'Docker',
          description: 'Containerización para despliegue consistente en diferentes entornos'
        },
        aws: {
          name: 'AWS',
          description: 'Infraestructura cloud para computación escalable y procesamiento de datos'
        },
        mathematics: {
          name: 'Matemáticas',
          description: 'Conceptos matemáticos avanzados subyacentes a las finanzas cuantitativas'
        },
        statistics: {
          name: 'Estadística',
          description: 'Métodos estadísticos para pruebas de hipótesis e inferencia'
        },
        linearalgebra: {
          name: 'Álgebra Lineal',
          description: 'Operaciones matriciales para optimización de portfolios y modelos factoriales'
        },
        timeseries: {
          name: 'Series Temporales',
          description: 'Análisis de datos temporales para pronósticos y detección de tendencias'
        },
        calculus: {
          name: 'Cálculo',
          description: 'Derivadas e integrales para pricing de opciones y optimización'
        },
        probability: {
          name: 'Probabilidad',
          description: 'Modelos probabilísticos para evaluación de riesgo y toma de decisiones'
        },
        optimization: {
          name: 'Optimización',
          description: 'Optimización matemática para asignación de portfolio y ajuste de estrategias'
        },
        bayesian: {
          name: 'Bayesiano',
          description: 'Inferencia bayesiana para detección de regímenes y estimación de parámetros'
        },
        montecarlo: {
          name: 'Monte Carlo',
          description: 'Métodos de simulación para análisis de riesgo y pruebas de escenarios'
        }
      },
      ctaTitle: '¿Listo para invertir diferente?',
      ctaSubtitle: 'Explora mis estrategias cuantitativas o ponte en contacto conmigo.',
      ctaStrategies: 'Ver Estrategias',
      ctaContact: 'Contacto',
      milestones: [
        {
          title: 'Grado en Física',
          description: 'Finalización del grado universitario con especialización en física teórica y matemática aplicada.',
          shortDetail: 'Fundamentos en cálculo, álgebra lineal, mecánica cuántica, mecánica estadística, electromagnetismo, relatividad y programación científica en Python/Fortran/C.'
        },
        {
          title: 'Master en Finanzas Cuantitativas',
          description: 'Formación especializada en modelización matemática, análisis cuantitativo y desarrollo de estrategias algorítmicas.',
          shortDetail: 'Programación Python, econometría, derivados, gestión de carteras, machine learning, deep learning, NLP, aprendizaje por refuerzo, despliegue AWS y computación cuántica.'
        },
        {
          title: 'Hedge Fund',
          description: 'Incorporación a hedge fund español trabajando con clientes institucionales de primer nivel.',
          shortDetail: 'Analista cuantitativo gestionando carteras para Edmond de Rothschild, Millennium y firmas estadounidenses. Estudios data-driven, optimización de procesos e investigación cuantitativa.'
        },
        {
          title: 'Trading Energético',
          description: 'Trading y gestión de riesgos en mercados energéticos globales para empresa holandesa.',
          shortDetail: 'Oportunidades de trading en interconexiones europeas. Proyectos de optimización para Repsol, Glencore, TMS. Reuters Eikon, desarrollo de ETRMs, solvers CPLEX/Gurobi, pricing Monte Carlo.'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'Analista cuantitativo en broker FTSE 100, desarrollando modelos de ML para optimización de trading y gestión de riesgos.',
          shortDetail: 'Modelos XGBoost/Random Forest para gestión de riesgos como market maker. Investigación estadística, pipelines de PnL, dashboards GCP/BigQuery/Streamlit. Reporting para equipos de Londres y Melbourne.'
        },
        {
          title: 'Estrategias en Producción',
          description: 'Desarrollo y operación de estrategias algorítmicas propietarias con capital real en múltiples clases de activos.',
          shortDetail: 'Market neutral, momentum, pair trading, trading basado en ML, forex, cripto, estrategias de volatilidad. Pipeline completo desde hipótesis hasta ejecución en vivo. Ver sección Strategies para más detalles.'
        }
      ],
      eventsTitle: 'EVENTOS',
      eventsAttendTitle: 'EVENTOS QUE ASISTO / RECOMIENDO',
      eventsOrganizeTitle: 'EVENTOS QUE ORGANIZO / DONDE HABLO',
      eventAttending: 'ASISTIENDO',
      eventOrganizer: 'ORGANIZADOR',
      eventQuantConference: 'Conferencia de Finanzas Cuantitativas',
      eventQuantConferenceLocation: 'Londres, Junio 2026',
      eventQuantConferenceDesc: 'Evento líder para investigadores y practicantes cuantitativos. Enfoque en trading sistemático y gestión de riesgos.',
      eventQuantMeetup: 'Meetup de Finanzas Cuantitativas',
      eventQuantMeetupLocation: 'Madrid, 2025',
      eventQuantMeetupDesc: 'Evento comunitario organizado para investigadores y practicantes cuantitativos. Enfoque en compartir estrategias de trading sistemático y networking.',
      eventsComingSoon: 'Más eventos próximamente...',
      podcastsTitle: 'PODCASTS · PRÓXIMAMENTE',
      podcastsDescription: 'Una serie de conversaciones con practicantes, investigadores y constructores en finanzas cuantitativas. Actualmente en planificación. Si quieres ser notificado cuando esto se lance, suscríbete vía la página de contacto.',
      disclaimer: 'La información proporcionada en este sitio es solo con fines educativos e informativos. No constituye asesoramiento financiero, de inversión o de trading. El rendimiento pasado no garantiza resultados futuros. Siempre consulta con un asesor financiero licenciado antes de tomar decisiones de inversión.',
    },

    // Strategies Page
    strategies: {
      title: 'Estrategias Cuantitativas',
      subtitle: 'Sistemas algorítmicos de grado institucional con backtesting riguroso',
      compareTitle: 'Comparación de Performance',
      compareSubtitle: 'Compara métricas clave de todas las estrategias',
      riskLevel: 'Nivel de Riesgo',
      moderate: 'Moderado',
      high: 'Alto',
      veryHigh: 'Muy Alto',
      viewStrategy: 'Ver Estrategia',
      equityCurve: 'CURVA DE EQUITY',
      drawdownAnalysis: 'ANÁLISIS DE DRAWDOWN',
      maxDrawdownComparative: 'MAX DRAWDOWN COMPARATIVO',
      comparativeMetrics: 'MÉTRICAS COMPARATIVAS',
      correlation: 'CORRELACIÓN',
      correlationWithBenchmarks: 'CORRELACIÓN CON BENCHMARKS',
      downloadBrochure: '📄 Descargar Brochure',
      annualReturns: 'Rentabilidades anuales',
      historicalDataDisclaimer: '* Datos históricos período {start} - {end}. Resultados pasados no garantizan rentabilidades futuras.',
      strategyNames: {
        tyr: 'Estrategia TYR',
        ares: 'Estrategia ARES',
        ascalafo: 'Estrategia ASCÁLAFO',
        deimos: 'Estrategia DEIMOS',
        fobos: 'Estrategia FOBOS',
        bes: 'Estrategia BES',
        janus: 'Estrategia JANUS',
        hraesvelgr: 'Estrategia HRÆSVELGR',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: 'Max DD',
        volatility: 'Volatilidad',
      },
      strategyDescriptions: {
        tyr: 'Rotación dual-momentum',
        ares: 'Market timing',
        ascalafo: 'Doble capa',
        deimos: 'Market timing + riesgo',
        fobos: 'Doble capa + riesgo',
        bes: 'Trend following',
        janus: 'Rotación sectorial',
        hraesvelgr: 'All Weather agresivo',
      },
      strategyFullDescriptions: {
        tyr: 'TYR toma su nombre del dios nórdico del orden, la justicia y la protección, un símbolo apropiado para una estrategia diseñada para navegar los mercados con disciplina y resiliencia. TYR es una estrategia cuantitativa de rotación dual-momentum inspirada en los principios de la filosofía All Weather de Ray Dalio.',
        ares: 'ARES es una estrategia cuantitativa propietaria de market timing. Desarrollada y validada en casi 20 años de datos históricos (2006–2026), ha demostrado robustez a través de los episodios de mayor estrés del mercado moderno: el crash financiero de 2008, la pandemia de 2020, el ciclo agresivo de subidas de tipos de 2022 y la volatilidad extrema de 2024–2025.',
        ascalafo: 'Estrategia propietaria de market timing de doble capa sobre el mercado estadounidense. Dos sistemas independientes de señal que se combinan para máxima precisión de entrada/salida. 100% sistemático, exposición binaria controlada.',
        deimos: 'DEIMOS es una estrategia cuantitativa propietaria de market timing con mayor riesgo controlado. Desarrollada y validada en casi 20 años de datos históricos (2006–2026), ha demostrado robustez a través de los episodios de mayor estrés del mercado moderno. Con un perfil de riesgo más agresivo que ARES, busca maximizar rendimientos en mercados alcistas manteniendo disciplina sistemática.',
        fobos: 'Estrategia propietaria de market timing de doble capa sobre el mercado estadounidense con perfil de alto riesgo/retorno. Dos sistemas independientes de señal que se combinan para máxima precisión de entrada/salida. 100% sistemático, exposición binaria controlada con apalancamiento optimizado para inversores con mayor tolerancia al riesgo.',
        bes: 'BES es una estrategia sistemática de trend following enfocada en crecimiento a medio plazo. Se queda con lo que va por delante del mercado amplio, combinando fuerza relativa, momentum y estabilidad de tendencia para filtrar el ruido.',
        janus: 'JANUS es un sistema de selección cuantitativa de acciones con rebalanceo semanal completo, que opera en modo Long-Short Market Neutral. Su nombre evoca al dios romano de las dos caras — exactamente la dualidad de tomar posiciones largas y cortas simultáneamente.',
        hraesvelgr: 'HRÆSVELGR es el gemelo más agresivo de TYR en la familia All Weather. La misma disciplina de regímenes, más apetito de crecimiento, y un giro más rápido a defensa cuando el momentum se apaga.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: 'Constructor de Portfolio',
      subtitle: 'Construye tu portfolio personalizado combinando múltiples estrategias cuantitativas',
      riskWarning: {
        title: '⚠ ADVERTENCIA DE RIESGO',
        content: 'Las estrategias cuantitativas implican riesgo de pérdida de capital. El rendimiento histórico mostrado se basa en backtesting y simulación — no garantiza retornos futuros. Esta es una herramienta educativa, no constituye asesoramiento de inversión, recomendación, ni solicitud de compra o venta de valores.',
      },
      hero: {
        heading1: 'CONSTRUYE TU',
        heading2: 'PORTFOLIO IDEAL',
        description: 'Explora combinaciones de portfolios con nuestras estrategias. Esta herramienta permite simular asignaciones, analizar métricas históricas y entender cómo diferentes pesos afectan la rentabilidad ajustada al riesgo. Esta es una herramienta educativa — no constituye asesoramiento de inversión personalizado.',
        disclaimer: 'Herramienta educativa únicamente. Resultados simulados basados en datos históricos. No constituye asesoramiento de inversión.',
      },
      tabs: {
        build: 'Construir Portfolio',
        models: 'Portfolios Modelo',
        saved: 'Portfolios Guardados',
      },
      buildSection: {
        selectTitle: 'Seleccionar Estrategias',
        selectSubtitle: 'Elige al menos 2 estrategias para combinar',
        weightsTitle: 'Asignar Pesos',
        weightsSubtitle: 'El total debe sumar 100%',
        totalWeight: 'Peso Total',
        distributeEqually: 'Distribuir Equitativamente',
        optimize: 'Auto Optimizar (Sharpe)',
        generate: 'Generar Portfolio',
        validationError: 'Selecciona al menos 2 estrategias y asegúrate de que los pesos suman 100%',
        optimizeSuccess: 'Portfolio optimizado con Sharpe esperado:',
        optimizeError: 'Error al optimizar portfolio',
      },
      modelsSection: {
        title: 'Portfolios Modelo',
        subtitle: 'Portfolios preconfigurados para diferentes perfiles de riesgo',
        usePortfolio: 'Usar Este Portfolio',
        questionnaire: 'Realizar Cuestionario',
      },
      savedSection: {
        title: 'Portfolios Guardados',
        subtitle: 'Accede a tus configuraciones de portfolio guardadas previamente',
        noSaved: 'No hay portfolios guardados aún',
        load: 'Cargar',
        delete: 'Eliminar',
      },
      results: {
        title: 'Resultados del Portfolio',
        composition: 'Composición del Portfolio',
        metrics: 'Métricas Clave',
        performance: 'Performance Histórica',
        returns: 'Retornos Mensuales',
        exportPDF: 'Descargar Reporte del Portfolio',
        save: 'Guardar Portfolio',
        saveSuccess: '¡Portfolio guardado con éxito!',
        saveError: 'Error al guardar portfolio',
        period: 'Período',
        strategies: 'Estrategias',
        tabs: {
          equity: 'Curva de Capital',
          drawdown: 'Drawdown',
          annual: 'Retornos Anuales',
        },
        metricLabels: {
          cagr: 'CAGR',
          totalReturn: 'Retorno Total',
          sharpe: 'Sharpe',
          sortino: 'Sortino',
          maxDD: 'Max DD',
          calmar: 'Calmar',
          volatility: 'Volatilidad',
          winRate: 'Win Rate',
          profitFactor: 'Profit Factor',
          bestWeek: 'Mejor Semana',
          worstWeek: 'Peor Semana',
        },
        quickStart: {
          model: 'Portfolio Modelo',
          modelDesc: 'Responde 5 preguntas y esta herramienta sugerirá un portfolio modelo basado en tu tolerancia al riesgo',
          models: 'Portfolios Modelo',
          modelsDesc: 'Elige entre 6 portfolios prediseñados por expertos: Conservador, Moderado, Agresivo, y más',
          auto: 'Optimización Automática',
          autoDesc: 'Algoritmo encuentra los pesos óptimos para maximizar Sharpe Ratio automáticamente',
        },
        manual: {
          title: 'Constructor Manual',
          selectTitle: 'Selecciona Estrategias y Asigna Pesos',
        },
      },
    },

    // Insights Page
    insights: {
      title: 'Análisis',
      subtitle: 'Estrategias, análisis y recursos para invertir de manera inteligente',
      substackSection: {
        title: 'ÚLTIMOS ARTÍCULOS DE SUBSTACK',
        loading: 'Cargando últimas publicaciones...',
        error: 'Error al cargar artículos. Inténtalo más tarde.',
        errorWithLink: 'Artículos recientes en Substack:',
      },
      newsletterTitle: 'HMA Quant Newsletter',
      visitSubstack: 'Visita mi Substack',
      weeklyNewsletter: 'Newsletter Semanal',
      analysisAndNewsletter: 'Análisis & Newsletter',
      subscribe: 'Suscribirse',
      newsletterIntro: 'Comparto análisis cuantitativo, tesis de inversión y notas diarias sobre el mapa de opciones del S&P500 en mi Substack',
      newsletterDescription: 'Recibe análisis técnico profundo, tesis de inversión cuantitativa y el mapa diario de opciones del S&P500 directamente en tu email. Contenido exclusivo para traders que buscan ventaja informativa.',
      newsletterBadge1: 'Análisis Cuantitativo',
      newsletterBadge2: 'Mapa de Opciones',
      newsletterBadge3: 'Tesis de Inversión',
      whereToInvestTitle: 'Dónde Invertir',
      whereToInvestSubtitle: 'Puedes seguir mis estrategias cuantitativas en las siguientes plataformas reguladas. Cada estrategia tiene su propio perfil de riesgo-retorno y está disponible para copy-trading o inversión directa.',
      darwinex: {
        title: 'Darwinex',
        description: 'Plataforma regulada FCA para copy-trading de estrategias algorítmicas',
        strategies: 'Estrategias',
      },
      etoro: {
        title: 'eToro',
        description: 'Plataforma de social trading con millones de usuarios en todo el mundo',
        profile: 'Mi Perfil',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: 'Plataforma europea para certificados de estrategias invertibles',
        profile: 'Mi Perfil',
      },
      resourcesTitle: 'Recursos Educativos',
      resourcesSubtitle: 'Artículos, herramientas y guías para mejorar tu inversión cuantitativa',
      comingSoon: 'Próximamente',
    },

    // Weekly Reports Page  
    weeklyReports: {
      title: 'Reportes Cuantitativos Semanales',
      subtitle: 'Suscríbete a reportes cuantitativos detallados de cada estrategia. Cada reporte incluye un análisis profundo del framework matemático, desarrollos semanales del modelo, movimientos del portfolio y el razonamiento cuantitativo detrás de la evolución de cada estrategia.',
      subscriptionOptions: 'Opciones de Suscripción',
      pricePerMonth: '€{price}/mes',
      subscribe: 'Suscribirse',
      manage: 'Gestionar Suscripción',
      alreadySubscribed: 'Ya Suscrito',
      signInToSubscribe: 'Inicia sesión para suscribirte',
      statusActive: 'Activo',
      statusCancelling: 'Cancela el {date}',
      statusExpired: 'Expirado',
      billingMonthly: 'Facturación mensual',
      cancelAnytime: 'Cancela cuando quieras',
      availableOnBrokers: 'Disponible en todos los principales brokers',
      assetsLabel: 'Activos:',
      whatYouGet: 'Qué obtienes:',
      subscribers: '{count} suscriptores',
      loading: 'Cargando...',
      errorLoading: 'Error al cargar',
      subscribeTo: 'Suscribirse a',
      subscribed: 'Suscrito',
      cancelsOn: 'Cancela el',
      completeBundle: 'Bundle Completo',
      completeBundleDesc: 'Todas las estrategias + Reportes de mercado + Visiones Quant Macro',
      bestValue: 'MEJOR VALOR',
      perMonth: '/mes',
      perYear: '/año',
      planMonthly: 'Mensual',
      planAnnual: 'Anual',
      twoMonthsFree: '2 meses gratis',
      equivMonthly: 'equiv. €{price}/mes',
      savingsText: '(€479,92 por separado — ahorras €184,93 + contenido macro)',
      savingsTextAnnual: '(€4.799,92 por separado — ahorras €1.849,93 + contenido macro)',
      getFullAccess: 'Obtener Acceso Completo',
      includes: 'Incluye:',
      bundleIncludes: {
        strategies: 'Las 22 estrategias (TYR, HRÆSVELGR, ARES, JANUS, BES, FOBOS, DEIMOS, ASCÁLAFO, EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER, HEIMDALL, METIS)',
        weeklyReports: 'Reportes semanales con análisis completo',
        macroInsights: 'Visiones macroeconómicas cuantitativas',
        historicalAccess: 'Acceso al archivo histórico completo',
        transparentSignals: 'Señales con razonamiento transparente',
      },
    },


    // Contact Page
    contact: {
      title: 'Hablemos',
      subtitle: '¿Interesado en estrategias cuantitativas, colaboraciones o contrataciones? Contacta conmigo.',
      formTitle: 'Envíame un Mensaje',
      formName: 'Nombre',
      formEmail: 'Email',
      formMessage: 'Mensaje',
      formSubmit: 'Enviar Mensaje',
      infoTitle: 'Información de Contacto',
      emailLabel: 'Email',
      emailLocked: 'Envía tu email arriba para desbloquear',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
    },

    // Returns Calculator Component
    calculator: {
      title: 'CALCULADORA DE RETORNOS',
      subtitle: 'Calcula cuánto habrías ganado invirtiendo en',
      historicalData: 'con datos históricos reales',
      initialInvestment: 'Inversión Inicial',
      monthlyContribution: 'Aportación Mensual (Opcional)',
      calculate: 'Calcular Retornos',
      results: {
        finalValue: 'VALOR FINAL',
        totalGain: 'GANANCIA TOTAL',
        returnPercent: 'RETORNO %',
        summary: 'Resumen:',
        summaryText1: 'Con una inversión inicial de',
        summaryText2: 'y aportaciones mensuales de',
        summaryText3: ', habrías invertido un total de',
        summaryText4: 'durante',
        summaryText5: ', obteniendo un valor final de',
        years: 'años',
      },
    },

    // Footer
    footer: {
      rights: 'Todos los derechos reservados',
      disclaimer: 'Rentabilidades pasadas no garantizan resultados futuros. El trading implica riesgo.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      legal: 'Aviso Legal',
    },

    // Common
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      viewMore: 'Ver Más',
      learnMore: 'Más Información',
      backToTop: 'Volver Arriba',
      downloadBrochure: 'Descargar Brochure',
    },

    // Terminal Page
    terminal: {
      // General
      quantLab: 'Laboratorio Cuantitativo',
      marketData: 'Datos de Mercado',
      derivatives: 'Derivados',
      signals: 'Señales',
      research: 'Investigación',
      controls: 'Controles',
      statistics: 'Estadísticas',
      numPaths: 'Número de Trayectorias',
      seed: 'Semilla Aleatoria',
      showPaths: 'Mostrar Trayectorias',
      showMean: 'Mostrar Media',
      showDistribution: 'Mostrar Distribución',
      showRegimes: 'Colorear por Régimen',
      terminalMean: 'Media Terminal',
      terminalStd: 'Desv. Est. Terminal',
      theoreticalMean: 'Media Teórica',
      theoreticalStd: 'Desv. Est. Teórica',
      stationaryMean: 'Media Estacionaria',
      stationaryStd: 'Desv. Est. Estacionaria',
      pricePaths: 'Trayectorias de Precios',
      meanReversion: 'Proceso de Reversión a la Media',
      terminalDistribution: 'Distribución Terminal',
      priceWithRegimes: 'Precio con Regímenes de Mercado',
      regimeStats: 'Estadísticas de Régimen',
      comingSoon: 'Próximamente',
      footer: 'Herramienta educativa para simulación de procesos estocásticos',
      
      // Modules
      macroTerminal: 'Terminal Macro',
      watchlist: 'Lista de Seguimiento',
      charts: 'Gráficos',
      heatmap: 'Mapa de Calor',
      optionsPricing: 'Valoración de Opciones',
      greeks: 'Calculadora de Greeks',
      volatilitySurface: 'Superficie de Volatilidad',
      liveSignals: 'Señales en Vivo',
      backtest: 'Motor de Backtest',
      economicCalendar: 'Calendario Económico',
      newsAnalysis: 'Análisis de Noticias',

      // GBM
      gbm: {
        name: 'Movimiento Browniano Geométrico',
        title: 'Movimiento Browniano Geométrico',
        subtitle: 'Modelo clásico para dinámica de precios con drift y volatilidad constantes',
        whatIs: '¿Qué es esto?',
        whatIsContent: 'Una receta matemática para generar trayectorias aleatorias de precios de acciones. Asume que el precio se mueve por una tasa de crecimiento promedio constante (drift) más ruido aleatorio proporcional al precio actual (volatilidad). Simple, poco realista y absolutamente fundamental.',
        whyMatters: '¿Por qué importa en finanzas?',
        whyMattersContent: 'Todos los libros de valoración de opciones comienzan aquí. Es el modelo detrás de la fórmula Black-Scholes ganadora del Nobel. Nos dice cómo se comportarían los rendimientos de acciones si el mundo fuera "normal" (literalmente — los rendimientos se distribuyen normalmente bajo GBM). Los mercados reales son más complejos: la volatilidad cambia, hay crashes, los rendimientos tienen colas gruesas. Pero todo modelo más sofisticado se construye sobre GBM o se prueba contra él.',
        symbolsTitle: 'Qué significa cada símbolo',
        symbols: {
          st: 'el precio de la acción en tiempo t',
          mu: 'rendimiento esperado anualizado (drift)',
          sigma: 'volatilidad anualizada',
          dt: 'un intervalo infinitesimal de tiempo',
          dwt: 'un pequeño shock aleatorio extraído de una distribución gaussiana (movimiento browniano)',
        },
        chartGuide: 'Cómo leer el gráfico',
        chartGuideContent: 'El eje x es tiempo en años. Cada línea de color es un futuro simulado del precio de la acción. La línea rosa gruesa es el promedio de todas las simulaciones. El histograma inferior muestra la distribución de precios FINALES (en tiempo T) a través de todas las trayectorias simuladas — debería verse log-normal.',
        playWith: 'Experimenta con esto',
        experiments: [
          'Ajusta σ a 0.01 (casi sin volatilidad): las trayectorias se vuelven casi deterministas. La acción simplemente crece exponencialmente a tasa μ.',
          'Ajusta σ a 0.80 (volatilidad muy alta): las trayectorias se dispersan salvajemente. Algunas trayectorias colapsan a cero.',
          'Ajusta μ a un número negativo: la acción cae en promedio, pero las trayectorias aún pueden subir debido al ruido.',
          'Compara Trayectorias=1 vs Trayectorias=100: las trayectorias individuales lucen estocásticas; los promedios de 100 lucen suaves. Esto es la Ley de los Grandes Números en acción.',
        ],
        inStrategies: 'En nuestras estrategias',
        inStrategiesContent: 'GBM es la hipótesis base contra la que probamos cada estrategia. Si una estrategia gana dinero con datos GBM, es sospechoso — GBM no tiene estructura explotable por diseño. Cualquier "ganancia de backtest" en GBM puro es un bug, overfitting o curve fitting. Estrategias como FOBOS explotan activamente cómo los mercados reales se desvían de GBM: la volatilidad real se agrupa, los rendimientos reales tienen colas gruesas, los crashes reales se agrupan en el tiempo.',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Proceso de Ornstein-Uhlenbeck',
        subtitle: 'Proceso de reversión a la media usado para tasas de interés, volatilidad y pairs trading',
        whatIs: '¿Qué es esto?',
        whatIsContent: 'Un proceso que vaga aleatoriamente, como GBM, pero con un giro crucial: es atraído de vuelta hacia un promedio de largo plazo. Cuanto más se aleja, más fuerte es la atracción. Piensa en él como un precio de acción en una banda elástica — el ruido lo estira, pero la banda siempre lo retrae.',
        whyMatters: '¿Por qué importa en finanzas?',
        whyMattersContent: 'Los precios de acciones individuales usualmente no revierten a la media (si una acción vale €100 hoy, no hay razón para que deba volver a €80 mañana). Pero los spreads entre activos relacionados sí lo hacen. Dos ETFs similares, dos acciones en la misma industria, dos rendimientos de bonos: su diferencia tiende a oscilar alrededor de un equilibrio. OU modela esa oscilación. Si podemos estimar la fuerza de atracción (κ) y el equilibrio (μ), sabemos cuándo el spread está lo suficientemente estirado para apostar por reversión.',
        symbolsTitle: 'Qué significa cada símbolo',
        symbols: {
          xt: 'el valor del spread en tiempo t',
          kappa: 'velocidad de reversión a la media. Mayor = vuelve más rápido',
          mu: 'el nivel de equilibrio de largo plazo',
          sigma: 'nivel de ruido (volatilidad)',
          dwt: 'el shock browniano aleatorio',
        },
        halfLife: 'Insight clave — vida media',
        halfLifeContent: 'El tiempo característico para que un shock decaiga a la mitad es ln(2) / κ. Si κ = 2, vida media ≈ 0.35 años (4 meses). Un shock hoy pierde la mitad de su magnitud en 4 meses. Si κ = 0.1, vida media ≈ 7 años — el spread deriva tan lentamente que apostar por reversión no tiene sentido.',
        chartGuide: 'Cómo leer el gráfico',
        chartGuideContent: 'El gráfico principal muestra el spread X_t a lo largo del tiempo. La línea horizontal punteada naranja es la media de largo plazo μ. Nota cómo el proceso vaga pero siempre es jalado de vuelta. El histograma muestra la distribución estacionaria (donde X pasa la mayor parte del tiempo): es gaussiana, centrada en μ, con varianza σ² / (2κ).',
        playWith: 'Experimenta con esto',
        experiments: [
          'Inicia X₀ lejos de μ (ej. X₀ = 4, μ = 0): observa qué tan rápido es jalado de vuelta. Con κ alto, es decisivo. Con κ bajo, toma una eternidad.',
          'Ajusta κ = 0: la reversión a la media desaparece. X deriva aleatoriamente. Esto es equivalente a movimiento browniano con drift.',
          'Ajusta σ muy bajo y κ alto: X converge rápidamente a μ y permanece casi pegado allí.',
          'Ajusta σ muy alto y κ bajo: X vaga grandes distancias. La distribución estacionaria es amplia.',
        ],
        inStrategies: 'En nuestras estrategias',
        inStrategiesContent: 'Este es literalmente el math detrás de ARES. Cuando detectamos un par potencialmente cointegrado de ETFs, ajustamos OU a su spread. Luego preguntamos: ¿es κ lo suficientemente alto para que la reversión ocurra en días, no meses? ¿Está el spread actualmente más de 2 desviaciones estándar de μ? Ambas condiciones cumplidas → tomamos el trade. κ demasiado bajo o spread cerca de μ → pasamos.',
      },

      // Greeks Explorer
      greeksExplorer: {
        name: 'Explorador de Greeks',
        title: 'GREEKS · SENSIBILIDADES DE OPCIONES',
        subtitle: 'Cómo el precio de la opción se mueve cuando cambian los inputs',
        introTitle: 'Introducción',
        introContent: 'Los Greeks son derivadas parciales de la fórmula Black-Scholes. Cada uno te dice cómo el precio de la opción responde a un cambio en un input. Los traders profesionales no miran precios de opciones — miran Greeks. Un portfolio con Delta = 0 es "delta-neutral" — inmune a pequeños movimientos del subyacente. Un portfolio con Gamma positivo es "long convexity" — se beneficia de cualquier gran movimiento arriba o abajo. Entender Greeks es entender cómo funcionan realmente las opciones.',
        controls: 'Controles',
        currentGreeks: 'Greeks Actuales',
        callOption: 'OPCIÓN CALL',
        putOption: 'OPCIÓN PUT',
        price: 'PRECIO',
        labels: {
          spotPrice: 'S (Precio Spot)',
          strike: 'K (Strike)',
          timeToExpiry: 'T (Tiempo a Vencimiento, años)',
          riskFreeRate: 'r (Tasa Libre de Riesgo)',
          volatility: 'σ (Volatilidad)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta es el ratio de cobertura. Un call con delta 0.5 significa que vendemos 0.5 acciones para cubrir 1 opción. Delta va de 0 a 1 para calls, -1 a 0 para puts.',
          formula: 'Fórmula',
          formulaNote: 'donde Φ es la función de distribución acumulativa normal estándar, y d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma mide qué tan rápido cambia delta. Gamma alta = delta cambia violentamente con pequeños movimientos de precio. Las opciones ATM tienen la gamma más alta.',
          formula: 'Fórmula',
          formulaNote: 'donde φ es la función de densidad de probabilidad normal estándar: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega mide sensibilidad a volatilidad. Opciones largas = volatilidad larga. Si σ sube 1%, el precio de la opción sube en Vega.',
          formula: 'Fórmula',
          formulaNote: 'Vega es igual para calls y puts. Se muestra por cambio del 1% en volatilidad.',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta es decaimiento temporal. Las opciones largas pierden valor con el paso del tiempo (theta negativo). Las opciones cortas se benefician (theta positivo) — la piedra angular de vender volatilidad.',
          formula: 'Fórmula',
          formulaNote: 'Se muestra por día. Theta es típicamente negativo para opciones largas (decaimiento temporal).',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho mide sensibilidad a tasas de interés. Para opciones de corto plazo, rho es pequeño. Para LEAPS, puede importar mucho.',
          formula: 'Fórmula',
          formulaNote: 'Se muestra por cambio del 1% en tasa libre de riesgo.',
        },
        inStrategies: 'Cómo HMA usa esto',
        fobosStrategy: 'FOBOS opera activamente volatilidad vía opciones. El Greek clave para FOBOS es Vega — cuando la volatilidad implícita es rica relativa a la realizada, FOBOS vende opciones para cosechar prima (Vega negativo). Cuando la vol implícita colapsa debajo de la realizada, FOBOS compra convexidad vía Gamma largo.',
        ascalafoStrategy: 'ASCÁLAFO ejecuta estrategias sistemáticas de opciones donde Theta y Gamma dominan. Theta es el "rendimiento" de vender tiempo, pero Gamma es el riesgo — un gran movimiento borra semanas de recolección de theta. El arte es dimensionar posiciones para que el ratio Theta/Gamma valga el riesgo.',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Derivación Black-Scholes',
        title: 'BLACK-SCHOLES · DESDE PRIMEROS PRINCIPIOS',
        subtitle: 'Cómo se construye realmente una ecuación que vale un Premio Nobel',
        tabs: {
          tab1: '01 · EL PROBLEMA',
          tab2: '02 · BINOMIAL',
          tab3: '03 · REPLICACIÓN',
          tab4: '04 · CONTINUO',
          tab5: '05 · LA EDP',
          tab6: '06 · FÓRMULA',
        },
        previous: 'ANTERIOR',
        next: 'SIGUIENTE',
        common: {
          stockPrice: 'Precio de Acción',
          strike: 'K',
          strikePrice: 'Precio Strike',
          spotPrice: 'Precio Spot',
          timeToExpiry: 'Tiempo a Vencimiento',
          riskFreeRate: 'Tasa Libre de Riesgo',
          volatility: 'Volatilidad',
          initialPrice: 'Precio Inicial',
          upFactor: 'Factor Subida',
          downFactor: 'Factor Bajada',
          timeStep: 'Paso Temporal',
          numberSteps: 'Número de Pasos',
          years: 'a',
        },
        tab1: {
          whatIsOption: '¿Qué es una opción?',
          whatIsOptionContent: 'Una opción call europea te da el derecho (no obligación) de COMPRAR un activo a un precio fijo K en una fecha fija T. Si el precio del activo S_T al vencimiento está por encima de K, ejerces y embolsas S_T - K. Si está por debajo, te vas con cero.',
          payoffFunction: 'La Función de Payoff',
          payoffDesc: 'Al vencimiento, la opción vale su valor intrínseco: la diferencia entre spot y strike, o cero.',
          interactivePayoff: 'Diagrama Interactivo de Payoff',
          stockPriceAtExpiry: 'Precio de Acción al Vencimiento',
          payoff: 'Payoff',
          callPayoff: 'Payoff Call',
          hockeyStick: 'La forma de palo de hockey: cero debajo de K, lineal arriba de K. La línea punteada muestra el strike.',
          theQuestion: 'La Pregunta que Black-Scholes Responde',
          questionText: '¿Cuánto deberíamos pagar HOY por el derecho de recibir max(S_T - K, 0) MAÑANA?',
          questionExplanation: 'El payoff es CONOCIDO dado S_T. El problema es que no sabemos S_T. Black-Scholes nos muestra cómo cubrir la incertidumbre completamente — bajo supuestos idealizados — y así fijar el precio justo de la opción.',
          assumptions: 'Supuestos',
          assumptionsList: [
            'La acción sigue Movimiento Browniano Geométrico (ver módulo GBM)',
            'Volatilidad constante σ',
            'Tasa libre de riesgo constante r',
            'Sin dividendos, sin costos de transacción, sin impuestos',
            'Trading continuo, liquidez perfecta',
            'Ejercicio europeo (solo en T, no antes)',
          ],
        },
        tab2: {
          simplestUniverse: 'El universo más simple posible',
          simplestUniverseContent: 'Un paso temporal. La acción es S₀ hoy. En el tiempo Δt sube a S_u = S₀·u (con probabilidad p) o baja a S_d = S₀·d (con probabilidad 1-p).',
          binomialTreeParams: 'Parámetros del Árbol Binomial',
          treeValues: 'Valores del Árbol',
          up: 'SUBE',
          down: 'BAJA',
          payoffUp: 'Payoff Subida',
          payoffDown: 'Payoff Bajada',
          wrongApproach: 'El enfoque INCORRECTO (probabilidad ingenua)',
          wrongApproachText: 'Simplemente tomar el promedio ponderado por probabilidad da:',
          wrongApproachWarning: 'PERO ESPERA — esto está mal. La p real no importa. El mercado no fija precios de opciones por "payoff esperado bajo probabilidad real". Los fija por REPLICACIÓN.',
        },
        tab3: {
          centralIdea: 'La idea central',
          centralIdeaContent: 'En lugar de adivinar probabilidades, construir un portfolio de acción + efectivo que dé el MISMO payoff que la opción en ambos escenarios. Por no-arbitraje, el costo de ese portfolio hoy debe igualar el precio de la opción.',
          replicationPortfolio: 'Portfolio de Replicación',
          replicationDesc: 'Portfolio = Δ acciones + B efectivo (prestado o invertido a tasa r)',
          solvingSystem: 'Resolviendo el Sistema',
          hedgeRatio: 'RATIO DE COBERTURA',
          cash: 'EFECTIVO',
          optionPrice: 'PRECIO OPCIÓN',
          riskNeutralProb: 'Probabilidad Risk-Neutral',
          riskNeutralText1: 'Después de álgebra, esto se simplifica a:',
          riskNeutralText2: 'donde la PROBABILIDAD RISK-NEUTRAL es:',
          profoundPoint: 'El punto profundo:',
          profoundText: 'Nota: la probabilidad real p nunca apareció. El precio de la opción solo depende de u, d, r, Δt, K. Esta es la magia del pricing risk-neutral — reemplazamos probabilidades reales con risk-neutral, descontamos por la tasa libre de riesgo, y llegamos al precio libre de arbitraje.',
          riskNeutralQ: 'q Risk-Neutral:',
          discountedPrice: 'Precio Descontado:',
        },
        tab4: {
          nStepIntro: 'Árbol de N pasos → Tiempo continuo',
          nStepContent: 'Extender el árbol binomial a N pasos entre 0 y T. Cuando N → ∞, con u y d elegidos apropiadamente, el árbol converge a GBM.',
          crrParams: 'Parámetros Cox-Ross-Rubinstein',
          crrExplanation: 'Con estas elecciones, el árbol binomial iguala los primeros dos momentos de GBM y converge al límite de tiempo continuo cuando N crece.',
          convergenceTitle: 'Convergencia a Black-Scholes',
          convergenceChart: 'Cuando N crece, el precio del árbol binomial converge al precio Black-Scholes.',
          continuousLimit: 'El Límite de Tiempo Continuo',
          continuousLimitContent: 'Cuando N → ∞ y Δt → 0, el árbol binomial se convierte en GBM, y el pricing discreto risk-neutral se convierte en el pricing continuo Black-Scholes. Pero necesitamos una herramienta más limpia: la EDP.',
        },
        tab5: {
          derivationIntro: 'Derivación desde Cálculo Estocástico',
          derivationContent: 'La acción sigue GBM bajo medida risk-neutral Q:',
          itosLemma: 'Lema de Itô',
          itosContent: 'Considerar una opción V(S, t). Por el lema de Itô:',
          hedgePortfolio: 'El Portfolio de Cobertura',
          hedgeContent: 'Portfolio Π = V - Δ·S donde Δ = ∂V/∂S. ¡El término dW se cancela! Π se vuelve determinístico.',
          noArbitrage: 'Condición de No-Arbitraje',
          noArbitrageContent: 'Un portfolio determinístico debe ganar la tasa libre de riesgo:',
          noArbitrageExplanation: 'Igualando esto a la expansión de Itô de Π da la EDP de Black-Scholes:',
          bsPDE: 'La EDP de Black-Scholes',
          boundaryConditions: 'Condiciones de Frontera',
          boundaryContent: 'Para un call europeo:',
          boundaryList: [
            'V(S, T) = max(S - K, 0) al vencimiento',
            'V(0, t) = 0 para todo t',
            'V(S, t) → S - K·e^(-r(T-t)) cuando S → ∞',
          ],
          keyInsight: 'Insight clave:',
          keyInsightContent: 'Esta es una EDP parabólica — la misma forma matemática que la ecuación del calor en física. Y como la ecuación del calor, tiene una solución de forma cerrada cuando la condición de frontera es el payoff de la opción call. Esa solución es la fórmula Black-Scholes.',
        },
        tab6: {
          closedFormIntro: 'La Fórmula de Forma Cerrada',
          closedFormContent: 'A través de un cambio de variables (log-precio, tiempo invertido, V normalizada), la EDP de Black-Scholes mapea exactamente a la ecuación del calor. La ecuación del calor tiene una solución fundamental gaussiana conocida, que cuando se transforma de vuelta da:',
          bsFormulaCall: 'Fórmula Black-Scholes para Call Europeo',
          bsFormulaWhere: 'donde Φ es la CDF normal estándar, y:',
          interactiveCalc: 'Calculadora Interactiva',
          callPrice: 'PRECIO CALL',
          putPrice: 'PRECIO PUT',
          priceVsSpot: 'Precio vs Spot · Descomposición de Valor Temporal',
          bsPrice: 'Precio BS',
          intrinsicValue: 'Valor Intrínseco',
          priceChartDesc: 'Línea sólida: precio BS. Línea punteada: valor intrínseco max(S-K, 0). La brecha es valor temporal.',
          impact: 'El Impacto',
          impactContent: 'Black y Scholes (y Merton) publicaron esto en 1973. Merton ganó el Nobel en 1997. Esta una ecuación cambió las finanzas para siempre. Todo después — volatilidad estocástica, difusiones de salto, vol local, SABR, vol rugosa — es un intento de arreglar sus fallas. Pero el andamiaje es el mismo: replicar, no-arbitraje, medida risk-neutral, EDP, expectativa.',
          greeksNext: 'El siguiente módulo (Explorador de Greeks) muestra las derivadas parciales de esta fórmula. Delta es ∂C/∂S. Gamma es ∂²C/∂S². Theta es -∂C/∂t. Vega es ∂C/∂σ. Rho es ∂C/∂r. Cada uno te dice cómo el precio reacciona a un input diferente.',
        },
      },

      // Regime Switching
      regime: {
        name: 'Cambio de Régimen',
        title: 'Modelo de Cambio de Régimen',
        subtitle: 'El comportamiento del mercado cambia entre regímenes alcista, neutral y bajista',
        whatIs: '¿Qué es esto?',
        whatIsContent: 'Los mercados reales no se comportan igual todo el tiempo. Hay períodos de tendencia tranquila donde las estrategias de momentum imprimen dinero. Períodos agitados dentro de rangos donde funciona la reversión a la media. Períodos de crisis donde las correlaciones se rompen, la volatilidad explota y todo va a efectivo. Un modelo de cambio de régimen dice: en lugar de UN conjunto de parámetros (μ, σ) para todo el mercado, hay N conjuntos, y el mercado cambia aleatoriamente entre ellos según una matriz de transición.',
        whyMatters: '¿Por qué importa en finanzas?',
        whyMattersContent: 'Una estrategia optimizada con datos de 2017 (tendencia de baja volatilidad) y desplegada en 2020 (crash COVID) es un desastre. Parámetros que eran óptimos en un régimen pueden ser catastróficos en otro. Las estrategias conscientes del régimen hacen dos cosas: detectar el régimen actual en tiempo real, y asignar capital a sub-estrategias que se ajustan a ese régimen. Esto es lo que separa un backtest ingenuo de algo resiliente.',
        symbolsTitle: 'Qué significa cada símbolo',
        symbols: {
          st: 'el régimen oculto en tiempo t (Alcista, Neutral o Bajista)',
          a: 'la matriz de probabilidad de transición. A[i][j] = probabilidad de saltar del régimen i al régimen j',
          mui: 'rendimiento esperado en régimen i (anualizado)',
          sigmai: 'volatilidad en régimen i (anualizado)',
        },
        chartGuide: 'Cómo leer el gráfico',
        chartGuideContent: 'La línea de precio muestra el precio del activo simulado. Los puntos de color muestran qué régimen estaba activo en cada momento: Verde = Alcista (alto μ, bajo σ), Amarillo = Neutral (μ neutral, σ medio), Rojo = Bajista (μ negativo, alto σ). Las estadísticas muestran qué fracción de la simulación se pasó en cada régimen.',
        playWith: 'Experimenta con esto',
        experiments: [
          'Haz Persistencia muy alta (ej. 0.97): los regímenes son "pegajosos" — una vez que estás en uno, tiendes a quedarte. Realista.',
          'Haz Persistencia muy baja (ej. 0.3): los regímenes parpadean rápidamente. No realista pero ilustrativo.',
          'Ajusta μ Bajista a -0.70: la crisis profunda arrastra el precio con fuerza. Ve cómo la mezcla de regímenes determina la trayectoria general.',
          'Ejecuta varias simulaciones: incluso con los mismos parámetros, diferentes semillas aleatorias dan trayectorias de precio dramáticamente diferentes, porque las secuencias de régimen difieren.',
        ],
        inStrategies: 'En nuestras estrategias',
        inStrategiesContent: 'DEIMOS ejecuta un Modelo Oculto de Markov en tiempo real. No ve el régimen directamente — observa rendimientos, volatilidad y correlaciones, e infiere qué régimen es más probable. Cuando DEIMOS dice "estamos en Crisis", toda la plataforma reduce exposición automáticamente. Otras estrategias usan detección de régimen como filtro: BES solo compra acciones cuando DEIMOS dice "Tendencia". FOBOS se cubre agresivamente cuando DEIMOS dice "Crisis". Por esto las estrategias tienen casi cero correlación con el S&P — no son solo posiciones largas en acciones con apalancamiento, son conscientes del régimen.',
      },
    },
};
